module.exports = __webpack_public_path__ + "img/RCT07.9ba4e69d.svg";